<template>
  <table border="1">
    <thead class="bg-warning">
      <tr>
        <th>Nama</th>
        <th>Absen</th>
        <th>Tgl Absen</th>
        <th>Desentif Absen</th>
        <th>Telat</th>
        <th>Tanggal Telat</th>
        <th>Desentive telat</th>
        <th>Desentive Total</th>
        <th>Note</th>
      </tr>
    </thead>
    <tbody>
      <template v-for="data in desentif">
        <tr>
          <td>{{data.name}}</td>
          <!--                    <template v-if="hidenn">-->
          <template>
            <td align="center">
              <template>
                <template v-if="data.absen.desentif != 0">
                  {{data.absen.desentif_detail.detail.absen_terdenda.length}}
                </template>
              </template>
            </td>
            <td>
              <template v-if="data.absen.desentif_detail.detail.absen_terdenda.length > 0">
                {{ data.absen.desentif_detail.detail.absen_terdenda | groupDate}}
              </template>
            </td>
            <td align="right">
              {{data.absen.desentif | pointmoneynotCurrency}}
            </td>
          </template>
          <td align="center">
            <template v-if="data.telat.desentif != 0">
              {{data.telat.desentif_detail.detail.telat_terdenda.length}}
            </template>
          </td>
          <td>
            <template v-if=" data.telat.desentif_detail.length == undefined && data.telat.desentif != 0">
              {{ data.telat.desentif_detail.detail.telat_terdenda| groupDate}}
            </template>
          </td>
          <td align="right">
            {{data.telat.desentif | pointmoneynotCurrency}}
          </td>
          <td align="right">
            {{ (data.telat.desentif + data.absen.desentif ) | pointmoneynotCurrency}}
          </td>
          <td>
            <template v-if="data.telat.desentif_detail.length == undefined">
              <template v-if="data.telat.desentif_detail.detail.tebus_bulan_depan.length > 0">
                <strong>Proses Tebus</strong> &nbsp;

                {{data.telat.desentif_detail.detail.tebus_bulan_depan | groupDate}}
              </template>
            </template>
          </td>
        </tr>
      </template>
      <tr class="bg-info">
        <td colspan="2">TOTAL</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td align="right">{{total | pointmoneynotCurrency}}</td>
        <td></td>
      </tr>
    </tbody>
  </table>
</template>
<script>
  export default {
      props: {
          desentif: {
              type: Array,
              default: () => []
          },
          total: {
              type: Number
          }
      },
  }
</script>

